// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGVerticalMenu = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#verticalMenu__clip0_12_2530)",
    children: [/*#__PURE__*/_jsx("path", {
      fillOpacity: 0.01,
      d: "M0 0h32v32H0z"
    }), /*#__PURE__*/_jsx("mask", {
      id: "verticalMenu__a",
      style: {
        maskType: 'alpha'
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 32,
      children: /*#__PURE__*/_jsx("g", {
        clipPath: "url(#verticalMenu__clip1_12_2530)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M16 25.144c1.262 0 2.286 1.024 2.286 2.286S17.262 29.716 16 29.716s-2.286-1.024-2.286-2.286 1.024-2.286 2.286-2.286zM16 13.716c1.262 0 2.286 1.023 2.286 2.285 0 1.263-1.024 2.286-2.286 2.286s-2.286-1.023-2.286-2.286c0-1.262 1.024-2.285 2.286-2.285zM16 2.287c1.262 0 2.286 1.023 2.286 2.286 0 1.262-1.024 2.286-2.286 2.286s-2.286-1.024-2.286-2.286c0-1.263 1.024-2.286 2.286-2.286z"
        })
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#verticalMenu__a)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0V0z"
      })
    })]
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsx("clipPath", {
      id: "verticalMenu__clip0_12_2530",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0z"
      })
    }), /*#__PURE__*/_jsx("clipPath", {
      id: "verticalMenu__clip1_12_2530",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0z"
      })
    })]
  })]
}));
SVGVerticalMenu.displayName = 'SVGVerticalMenu';
export default SVGVerticalMenu;